import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useData } from '../../context/DataContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSave, FiImage, FiLayout } = FiIcons;

const BrandingSettings = () => {
  const { settings, updateSettings } = useData();
  const [formData, setFormData] = useState(settings.branding);
  const [successMsg, setSuccessMsg] = useState('');

  useEffect(() => {
    setFormData(settings.branding);
  }, [settings.branding]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateSettings('branding', formData);
    setSuccessMsg('Branding settings updated successfully!');
    setTimeout(() => setSuccessMsg(''), 3000);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
    >
      <div className="flex items-center space-x-2 mb-6 border-b border-gray-100 pb-4">
        <SafeIcon icon={FiLayout} className="w-5 h-5 text-blue-600" />
        <h2 className="text-lg font-semibold text-gray-900">White Labelling & Branding</h2>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Application Name
            </label>
            <input
              type="text"
              name="appName"
              value={formData.appName}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="e.g. My CRM"
            />
            <p className="text-xs text-gray-500 mt-1">Displayed in the browser tab and sidebar header.</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Company Name
            </label>
            <input
              type="text"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="e.g. Acme Corp"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Logo URL
          </label>
          <div className="flex space-x-4">
            <div className="flex-1">
              <div className="relative">
                <SafeIcon icon={FiImage} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="url"
                  name="logoUrl"
                  value={formData.logoUrl}
                  onChange={handleChange}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="https://example.com/logo.png"
                />
              </div>
              <p className="text-xs text-gray-500 mt-1">Leave empty to use the default icon.</p>
            </div>
            {formData.logoUrl && (
              <div className="w-12 h-12 bg-gray-50 border border-gray-200 rounded-lg flex items-center justify-center p-1">
                <img src={formData.logoUrl} alt="Preview" className="max-w-full max-h-full object-contain" />
              </div>
            )}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Footer Text
          </label>
          <input
            type="text"
            name="footerText"
            value={formData.footerText}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="e.g. © 2024 Acme Corp. All rights reserved."
          />
        </div>

        {successMsg && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            className="bg-green-50 text-green-700 px-4 py-3 rounded-lg text-sm"
          >
            {successMsg}
          </motion.div>
        )}

        <div className="flex justify-end pt-4 border-t border-gray-100">
          <button
            type="submit"
            className="flex items-center space-x-2 bg-blue-600 text-white px-6 py-2.5 rounded-lg hover:bg-blue-700 transition-colors shadow-sm"
          >
            <SafeIcon icon={FiSave} className="w-4 h-4" />
            <span>Save Branding</span>
          </button>
        </div>
      </form>
    </motion.div>
  );
};

export default BrandingSettings;